import { Link } from 'react-router-dom';
import WowpressPricePreview from './WowpressPricePreview';
import styles from './Wowpress.module.scss';

function Wowpress() {
  return (
    <div className={styles.page}>
      {/* PAGE HEAD */}
      <section className={styles.pageHead}>
        <div className={styles.crumb}>
          <Link to="/">HOME</Link>
          <svg viewBox="0 0 24 24">
            <path d="m9 18 6-6-6-6" />
          </svg>
          <Link to="/order">주문하기</Link>
          <svg viewBox="0 0 24 24">
            <path d="m9 18 6-6-6-6" />
          </svg>
          <span className={styles.crumbHere}>디자인 있음</span>
        </div>
        <span className={styles.eyebrow}>Print Order</span>
        <h1 className={styles.pageTitle}>
          <em>인쇄 주문</em> · 실시간 견적
        </h1>
        <p className={styles.pageDesc}>
          인쇄용 디자인 파일을 가지고 계신 고객을 위한 주문 화면입니다. 상품과 옵션을 선택해 가격을 확인한 뒤
          &lsquo;주문서 작성&rsquo;으로 이어서 디자인 파일을 첨부해주세요.
        </p>
      </section>

      {/* LAYOUT */}
      <section className={styles.layout}>
        <div className={styles.main}>
          <WowpressPricePreview />
        </div>
      </section>
    </div>
  );
}

export default Wowpress;
